import React from 'react'

import './style.css'

const PieTimerAnimation = () => {
    return (
        <div className="wrapper">
            <div className="pie filler"></div>
            <div className="pie spinner"></div>
            <div className="mask"></div>
        </div>
    )
}

export default PieTimerAnimation
